import { AssetAppeal, ReferralRespondBack, Report } from "types";
import apiClient from "../lib/apiClients";

// Asset Appeal Request
export const createAssetAppeal = async (data: any) => {
  const response = await apiClient.post<AssetAppeal>(
    "asset_recovery_appeal/appeal-requests/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const getAssetAppealsByAdminUnit = async (adminUnitId: string) => {
  const response = await apiClient.get<AssetAppeal[]>(
    `asset_recovery_appeal/appeal-requests/filter-by-admin-unit/?admin_unit=${adminUnitId}`
  );
  return response.data;
};
export const getAssetAppealsByProsecutor = async (prosecutorId: string) => {
  const response = await apiClient.get<AssetAppeal[]>(
    `asset_recovery_appeal/appeal-requests/filter-by-prosecutor/?prosecutor_id=${prosecutorId}`
  );
  return response.data;
};

export const getAssetAppealById = async (id: string) => {
  const response = await apiClient.get<AssetAppeal>(
    `asset_recovery_appeal/appeal-requests/${id}/`
  );
  return response.data;
};

export const updateAssetAppeal = async (id: string, data: any) => {
  const response = await apiClient.patch(
    `asset_recovery_appeal/appeal-requests/${id}/`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const addAssetAppealRespondBack = async (data: any) => {
  const response = await apiClient.post(
    `asset_recovery_appeal/appeal-feedbacks/`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const getAssetAppealRespondBacksByAppealId = async (id: string) => {
  const response = await apiClient.get<ReferralRespondBack[]>(
    `asset_recovery_appeal/appeal-feedbacks/filter-by-asset-appeal-request/?asset_appeal_request=${id}`
  );
  return response.data;
};

export const getAssetAppealReportsByAppeallId = async (id: string) => {
  const response = await apiClient.get(
    `asset_recovery_appeal/daily-reports/by-appeal-request/?asset_appeal_request=${id}`
  );
  return response.data;
};

export const addAppealReport = async (data: any) => {
  const response = await apiClient.post(
    `asset_recovery_appeal/daily-reports/`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const addRespondantAppeal = async (data: any) => {
  const response = await apiClient.post(
    `asset_recovery_appeal/asset-appeal-respondant/`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const getRespondentAssetAppealsByAdminUnit = async (
  adminUnitId: string
) => {
  const response = await apiClient.get<AssetAppeal[]>(
    `asset_recovery_appeal/asset-appeal-respondant/by-admin-unit/?admin_unit=${adminUnitId}`
  );
  return response.data;
};
export const getRespondentAssetAppealsByProsecutor = async (
  prosecutorId: string
) => {
  const response = await apiClient.get<AssetAppeal[]>(
    `asset_recovery_appeal/asset-appeal-respondant/by-assigned-prosecutor/?assigned_prosecutor_id=${prosecutorId}`
  );
  return response.data;
};

export const getRespondentAssetAppealById = async (id: string) => {
  const response = await apiClient.get<AssetAppeal>(
    `asset_recovery_appeal/asset-appeal-respondant/${id}/`
  );
  return response.data;
};

export const updateRespondentAssetAppeal = async (id: string, data: any) => {
  const response = await apiClient.patch(
    `asset_recovery_appeal/asset-appeal-respondant/${id}/`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const getRespondentAssetAppealFeedbacks = async (id: string) => {
  const response = await apiClient.get<ReferralRespondBack[]>(
    `asset_recovery_appeal/asset-appeal-respondant/${id}/feedbacks/`
  );
  return response.data;
};

export const getRespondentAssetAppealReportss = async (id: string) => {
  const response = await apiClient.get<Report[]>(
    `asset_recovery_appeal/asset-appeal-respondant/${id}/daily-reports/`
  );
  return response.data;
};
